import { DataGridContextProvider } from '@cmg/data-grid';
import { Grid, Section } from '@cmg/design-system';

import type { RolodexRecordStatus } from '../../../../../../graphql';
import { AddSalesCoverage } from './AddSalesCoverage/AddSalesCoverage';
import { InvestorCoverageGrid } from './InvestorCoverageGrid/InvestorCoverageGrid';

export type InvestorCoverageSectionProps = Readonly<{
  tenantId?: string;
  employeeId: string;
  employeeStatus: RolodexRecordStatus;
}>;

const SECTION_SLOT_PROPS = { content: { height: '100%' } };

export function InvestorCoverageSection({
  tenantId,
  employeeId,
  employeeStatus,
}: InvestorCoverageSectionProps) {
  return (
    <DataGridContextProvider>
      <Grid item xs={12} minHeight={650}>
        <Section
          title="Investor Coverage"
          height="100%"
          slotProps={SECTION_SLOT_PROPS}
          actions={[
            <AddSalesCoverage
              key="add-sales-coverage-button"
              tenantId={tenantId}
              employeeId={employeeId}
              employeeStatus={employeeStatus}
            />,
          ]}
        >
          <InvestorCoverageGrid employeeId={employeeId} employeeStatus={employeeStatus} />
        </Section>
      </Grid>
    </DataGridContextProvider>
  );
}
